var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ac_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac_logo",
    fill: "#F01428",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,14.8 C11,14.1 11.3,14 12,14.4 C13.2,15.1 14.4,15.7 14.4,15.7 C14.4,15.3 14.8,15 15.5,15.2 C16.2,15.4 16.9,15.5 16.9,15.5 C16.9,15.5 16.5,14.6 16.3,14.2 C16,13.5 16.3,13.1 16.6,13 C16.6,13 16.2,12.7 15.9,12.5 C15.3,12.1 15.4,11.6 16,11.4 C16.8,11 17.9,10.6 17.9,10.6 C17.6,10.4 17.2,9.9 17.6,9.2 C18,8.6 18.7,7.7 18.7,7.7 C18.7,7.7 17.6,7.7 16.8,7.7 C16.1,7.7 15.9,7.1 15.9,6.7 C15.9,6.7 14.8,7.5 14,8 C13.3,8.5 12.7,8 12.8,7.2 C13,6 13.1,4.6 13.1,4.6 C12.7,5 12,4.9 11.6,4.3 C11.1,3.3 10.6,2.1 10.6,2.1 C10.6,2.1 10.1,3.3 9.6,4.3 C9.3,4.9 8.6,5 8.2,4.7 C8.2,4.7 8.3,6.1 8.5,7.3 C8.6,8 8,8.5 7.3,8 C6.5,7.5 5.3,6.7 5.3,6.7 C5.3,7.1 5.1,7.6 4.4,7.7 C3.6,7.7 2.5,7.7 2.5,7.7 C2.5,7.7 3.2,8.6 3.6,9.2 C4,9.8 3.6,10.4 3.3,10.6 C3.3,10.6 4.3,11.1 5.2,11.4 C5.8,11.7 6,12.1 5.3,12.5 C5.1,12.7 4.6,13 4.6,13 C5,13.1 5.3,13.5 5,14.2 C4.8,14.6 4.4,15.5 4.4,15.5 C4.4,15.5 5.1,15.3 5.8,15.2 C6.5,15 6.8,15.4 6.9,15.7 C6.9,15.7 8.1,15 9.3,14.4 C9.9,14 10.3,14.2 10.3,14.8 L10.3,16.5 C10.3,17.5 10.1,18.5 9.8,19.1 C5.3,18.6 1.5,15 1.5,10.2 C1.5,5.3 5.6,1.3 10.7,1.3 C15.8,1.3 19.9,5.3 19.9,10.2 C19.9,14.8 16.3,18.6 11.7,19.1 L11.7,20.3 C17.1,19.8 21.3,15.5 21.3,10.2 C21.3,4.5 16.5,0 10.6,0 C4.8,0 0,4.5 0,10.1 C0,15 3.7,19.1 8.6,20 C9.4,20.2 9.9,20.3 10.4,20.8 C10.9,19.8 11,17.8 11,16.7 L11,14.8 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.514cbfc1a1d5da51b12c83993b452209.svg";
export { ForwardRef as ReactComponent };